import { inputToTags, tagsToInput } from "../../mst/kinds/utils";
import { CreateAgent } from "../../schema/types/agent/create";
import { Agent } from "../../schema/types/agent/entity";
import { AgentInput } from "../../schema/types/agent/input";
import { getDefaultBaseInput, OptimisticConcurrency } from "../../schema/types/base";

export function getDefaultAgentInput(): AgentInput {
  return {
    ...getDefaultBaseInput(),
    version: 0,
    id: "",
    meta: {
      isEdit: false,
    },
  };
}

export function inputToAgent(input: AgentInput): CreateAgent {
  const res: CreateAgent = {
    name: input.name,
    kind: "agent",
    tags: inputToTags(input.tags),
  };
  if (input.description) {
    res.description = input.description;
  }
  return res;
}

export function agentToInput(agent: Agent): AgentInput {
  const defaultInput = getDefaultAgentInput();

  const res: AgentInput = {
    ...defaultInput,
    id: agent.id,
    version: agent.version,
    name: agent.name,
    description: agent.description,
    tags: tagsToInput(agent.tags),
    meta: {
      ...defaultInput.meta,
      isEdit: true,
    },
  };
  return res;
}

export function agentToPatch(_agent: CreateAgent, concurrency: OptimisticConcurrency) {
  const agent: any = JSON.parse(JSON.stringify(_agent));

  agent[`$replace/tags`] = agent.tags;
  delete agent.tags;

  agent.id = concurrency.id;
  agent.version = concurrency.version;

  return agent;
}
